import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import { ReportData } from 'src/suitability-report/SuitabilityFlow';
import { SettingsRow } from 'src/suitability-report/SettingsRow';
import { Flex } from '@mantine/core';
import { DataInput } from 'src/data-capture/detected-entities/DataInput';
import { FieldTypeMetadata } from 'src/data-capture/types';
import SelectClientOrFamilyStep from 'src/UI/drawer-flow/SelectClientOrFamilyStep';

export default function SelectSuitabilityReportClientStep(props: StepProps<ReportData>) {
  const { data, setData } = props;
  const lastReviewDate = new Date(data.lastClientReview ?? new Date())?.toISOString();

  const StepComponent = SelectClientOrFamilyStep;

  return (
    <StepComponent
      {...props}
      description={'Select the client you wish to generate a report for'}
      footer={
        <SettingsRow
          title="Take into account the last review"
          checked={data.enableLastReview}
          onChange={value => props.setData({ ...data, enableLastReview: value })}
          showDivider={false}
          tooltip={'hello'}
          right={
            data.enableLastReview && (
              <Flex justify="space-between" align="center">
                <DataInput
                  editable={true}
                  metadata={
                    {
                      type: 'DATE',
                      isOptional: false,
                      valueFormat: 'DD/MM/YYYY',
                    } as FieldTypeMetadata
                  }
                  value={lastReviewDate}
                  onChange={value => {
                    const date = value ? new Date(String(value)) : new Date();
                    setData({ ...data, lastClientReview: date });
                  }}
                  editIconColor="brand.6"
                >
                  {data.lastClientReview?.toLocaleDateString('en-GB') || 'No previous review found'}
                </DataInput>
              </Flex>
            )
          }
        />
      }
    />
  );
}
